import Swiper from 'swiper/bundle'
var Isotope = require('isotope-layout')
import { gsap } from 'gsap'
import DrawnSVGPlugin from 'gsap/DrawSVGPlugin'

/**
 * Treatments Module functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class TreatmentsModule {
  /**
     * Constructs a new TreatmentsModule instance.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */

  constructor(options) {
    this.element = options.element
    this.swiperElement = this.element.querySelector('.swiper')
    this.swiperWrapper = this.element.querySelector('.swiper-wrapper')
    this.swiperButtonPrev = this.element.querySelector('[data-component="slider-prev-btn"]')
    this.swiperButtonNext = this.element.querySelector('[data-component="slider-next-btn"]')
    this.carbonLaserPeelElement = this.element.querySelector('#carbon-laser-peel')
    this.mediaQuery = window.matchMedia('(min-width: 64rem)')

    if (this.mediaQuery.matches) {
      const iso = new Isotope('.grid', {
        itemSelector: '.element-item',
        transitionDuration: 0
      })

      const treatmentsSlider = new Swiper(this.swiperElement, {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 0,
        navigation: {
          nextEl: this.swiperButtonNext,
          prevEl: this.swiperButtonPrev,
        },
        breakpoints: {
          320: {
            slidesPerView: 2
          },
          480: {
            slidesPerView: 3
          },
          640: {
            slidesPerView: 4
          },
          768: {
            slidesPerView: 6
          },
          1300: {
            slidesPerView: 10
          }
        },
      })

      // bind filter button click
      var filtersElem = document.querySelector('.filters-button-group')
      filtersElem.addEventListener('click', (event) => {
        var filterValue = event.target.getAttribute('data-filter')
        iso.arrange({ filter: filterValue })
      })

      // change is-checked class on buttons
      var buttonGroups = document.querySelectorAll('.button-group');
      for (var i = 0, len = buttonGroups.length; i < len; i++) {
        var buttonGroup = buttonGroups[i]
        this.radioButtonGroup(buttonGroup, treatmentsSlider)
      }
    }
  }
  radioButtonGroup(buttonGroup, treatmentsSlider) {
    buttonGroup.addEventListener('click', (event) => {
      treatmentsSlider.update()
      buttonGroup.querySelector('.is-checked').classList.remove('is-checked')
      event.target.classList.add('is-checked')
    })
  }
}